module.exports = __webpack_public_path__ + "static/itemsline-c94c8477fa028b9823ac388e39accac6.png";